<template>
  <div class="fabric-info__container">
    <div class="fabric-info__wrapper d-flex">
      <div class="fabric-img__wrapper">
        <el-image
          :src="
            formData.defaultImageUrl
              ? $osscdn(formData.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            formData.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          class="fabric-img"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" class="fabric-img" />
          </div>
        </el-image>
        <div class="operate-button__wrapper" :class="{ edit: edit }">
          <i
            class="button-icon el-icon-edit"
            @click="editSpec"
            v-if="!edit"
          ></i>
          <i class="button-icon el-icon-delete red" @click="delSpec"></i>
        </div>
      </div>

      <div class="fabric-detail__wrapper">
        <el-form
          ref="form"
          :model="formData"
          :disabled="disabled"
          :rules="rules"
          size="mini"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricColorNo') || '面料编号'"
                prop="fabricColorNo"
              >
                <el-input
                  v-model="formData.fabricColorNo"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.evg_sku_label_fabricColorTitle1') || '面料颜色'
                "
                prop="fabricColorTitle"
              >
                <el-input
                  v-model="formData.fabricColorTitle"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="9">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricName') || '面料名称'"
                prop="fabricName"
              >
                <el-input
                  v-model="formData.fabricName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="15">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricContent') || '面料成分'"
                prop="fabricContent"
              >
                <FabricContentInput
                  :fabricContent.sync="formData.fabricContent"
                  :fabricContentEn.sync="formData.fabricContentEn"
                  :disabled="disabled"
                  size="mini"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricWeights') || '面料克重'"
                prop="fabricWeight"
              >
                <el-input
                  v-model="formData.weightUnit"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_yarnCount') || '纱支'"
                prop="yarnCount"
              >
                <el-input
                  v-model="formData.yarnCount"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="50"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_density') || '密度'"
                prop="density"
              >
                <el-input
                  v-model="formData.density"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="50"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_isSpecify') || '是否指定供应商'"
                prop="isSpecify"
              >
                <el-select
                  v-model="formData.isSpecify"
                  :disabled="!edit || disabled"
                  size="mini"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  style="width: 100%"
                  filterable
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item
                :label="
                  $l('INDEX.evg_sku_label_isCustomerProvide') || '是否客供面料'
                "
                prop="isCustomerProvide"
              >
                <el-select
                  v-model="formData.isCustomerProvide"
                  :disabled="!edit || disabled"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  style="width: 100%"
                  filterable
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_supCode') || '供应商'"
                prop="scmCode"
              >
                <dict-select
                  size="mini"
                  :disabled="!edit || disabled"
                  clearable
                  filterable
                  v-model="formData.scmCode"
                  url="/master/common/dict/scmCooperated"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_unitPrice') || '面料单价'"
                prop="unitPrice"
              >
                <el-input-number
                  v-model="formData.unitPrice"
                  :disabled="disabled"
                  style="width: 100%; text-align: left"
                  controls-position="right"
                  :precision="2"
                  :min="0"
                  :max="999999999"
                  :step="0.01"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricUnit') || '面料单位'"
                prop="fabricUnit"
              >
                <dict-select
                  v-model="formData.fabricUnit"
                  url="/digitalCenter/common/dict/biz"
                  :body="{ dictType: 'fabricYarnUnit' }"
                  size="mini"
                  :disabled="disabled"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="20">
              <el-form-item
                :label="$l('INDEX.form_label_proof_remark') || '具体说明'"
                prop="isSpecify"
              >
                <el-input
                  v-model="formData.notes"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  rows="4"
                  type="textarea"
                  maxlength="400"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import FabricContentInput from '@/views/digital/components/fabric-content-input'
export default {
  props: {
    fabricInfo: { type: Object, default: () => {} },
    currIndex: { type: Number, default: -1 },
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    showSaveButton: { type: Boolean, default: true },
  },
  components: { FabricContentInput },
  mixins: [EditLoading],
  data() {
    return {
      formData: {},
      selectOptions: [
        { label: this.$l('INDEX.YES') || '是', value: 'Y' },
        { label: this.$l('INDEX.NO') || '否', value: 'N' },
      ],
      edit: true,
      showImageChoose: false,
      rules: {
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricColorNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricColorTitle: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricContent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  watch: {
    fabricInfo: {
      handler() {
        this.formData = {
          ...this.fabricInfo,
          isSpecify: this.fabricInfo.isSpecify
            ? this.fabricInfo.isSpecify
            : 'N',
          isCustomerProvide: this.fabricInfo.isCustomerProvide
            ? this.fabricInfo.isCustomerProvide
            : 'N',
          weightUnit:
            this.fabricInfo.fabricWeight +
            ' ' +
            this.fabricInfo.fabricWeightUnit,
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getFabricData() {
      return this.formData
    },

    editSpec() {
      this.edit = true
    },
    delSpec() {
      this.$emit('delFabric', this.currIndex)
    },
    setImage({ displayImageCode, displayImageUrl }) {
      this.formData.defaultImageUrl = displayImageUrl
      this.formData.defaultImageCode = displayImageCode
      this.showImageChoose = false
    },
    openImgChoose() {
      this.showImageChoose = true
      this.edit = true
    },
    getDetail(proofingFabricCode) {
      this.$api
        .customerProofingFabricDetailApi({
          proofingFabricCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
          this.$emit('updateFabric', this.currIndex, this.formData)
        })
    },
    async validateForm() {
      const result = await validate.formValidate([this.$refs.form])
      return result
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      // const res = await this.$api
      //   .ecomEvgSkuSpecFabricSaveApi({
      //     ...this.formData,
      //     proofingCode: this.proofingCode,
      //   })
      //   .catch(() => null)
      // if (!res || !res.body) {
      //   this.loadingClose()
      //   return
      // }
      this.loadingClose()
      this.getDetail(res.body)
      this.edit = false
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-info__container {
  margin-top: 10px;
  border-radius: 5px;
  background-color: #f4f6f9;
  color: #101010;
  padding: 15px 15px;
  .fabric-img__wrapper {
    .operate-button__wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      > i {
        font-size: 20px;
        margin-left: 15px;
      }
      i:last-child {
        margin-right: 15px;
      }
      .red {
        color: #fa5c7c;
      }
    }
    .operate-button__wrapper.edit {
      justify-content: center;
    }
    .fabric-img {
      width: 117px;
      height: 77px;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      margin-bottom: 15px;
      > img {
        width: 117px;
        height: 77px;
        border-radius: 3px;
      }
    }
    > img {
      width: 96px;
      height: 96px;
      border-radius: 3px;
    }
  }

  .fabric-detail__wrapper {
    flex: 1;
    margin-left: 15px;
    .modify-info {
      display: flex;
      align-items: flex-end;
      color: #8e8e8e;
      font-size: 14px;
    }
  }
}
::v-deep {
  .fabric-detail__wrapper {
    .el-form-item__label {
      line-height: 30px !important;
    }
    .el-form-item {
      margin-bottom: 8px !important;
    }
  }
}
.input-append__button {
  cursor: pointer;
  background-color: #a4adb3;
  color: white;
}
.button-icon {
  cursor: pointer;
}
</style>
